export default "__VITE_ASSET__CeD5LZKJ__"